/* eslint-disable @typescript-eslint/no-explicit-any */
import { CONSTANTS } from "@constants/index";
import { trackResponseError } from "@utils/analytics";
import commonUtils from "@utils/common.utils";

function handleResponse(
  res: any,
  navigate?: any,
  showErrorToast: boolean = true
) {
  if (res.ok) return res;

  if (res && !res.ok) {
    const errorMessage =
      commonUtils.getErrorMessage(res) ||
      res?.problem ||
      "Something went wrong";
    trackResponseError(res, errorMessage);
  }

  const isKiosk = import.meta.env.VITE_APP_TARGET === "kiosk";

  const {
    BAD_REQUEST,
    DEVICE_DISCONNECTED,
    DEVICE_ERROR,
    FORBIDDEN,
    INTERNAL_SERVER_ERROR,
    INVALID_DATA,
    NOT_FOUND,
    UNAUTHORIZED,
  } = CONSTANTS.HTTP_STATUS;

  switch (res.status) {
    case FORBIDDEN:
    case NOT_FOUND:
    case INTERNAL_SERVER_ERROR:
    case INVALID_DATA:
      if (showErrorToast) commonUtils.showErrorToast(res);
      break;

    case DEVICE_ERROR:
      commonUtils.clearUserSession(true);
      if (showErrorToast) commonUtils.showErrorToast(res);
      break;

    case DEVICE_DISCONNECTED:
      if (navigate && isKiosk) {
        setTimeout(() => {
          navigate("/device-error");
        }, 2000);
      }
      break;

    case UNAUTHORIZED:
      commonUtils.clearUserSession(false);
      if (showErrorToast) commonUtils.showErrorToast(res);

      if (navigate) {
        setTimeout(() => {
          navigate("/");
        }, 2000);
      }
      break;

    case BAD_REQUEST:
      return res;

    default:
      if (showErrorToast) commonUtils.showErrorToast(res);
      return res;
  }

  return res;
}

export default handleResponse;
